import React, { useState } from 'react';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import dayjs, { Dayjs } from "dayjs";

interface DateEditorProps {
    value?: any;
  onChange?: (date: string) => void;
  label?: string;
  disabled?: boolean;
  min?: string;
  max?: string;
}

const DateEditor: React.FC<DateEditorProps> = ({
  value = '',
  onChange,
  label,
  disabled = false,
  min,
  max,
}) => {
    const momentDate = value
        ? dayjs(value): null;

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className="date-editor">
      {label && <label>{label}</label>}
          <DatePicker
              placeholder='Select Date' value={momentDate} format="MM/DD/YYYY" style={{ width: '100%' }}
              onChange={handleChange} getPopupContainer={trigger => trigger.parentNode} disabled={disabled}

        />
    </div>
  );
};

export default DateEditor;